import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var AccessLogsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AccessLogsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create accessLog with given role
     *
     * @since 1.0.0
     *
     * @param data New accessLog's data
     */
    AccessLogsService.prototype.create = function (roleType, companyId, type, firstName, lastName, companyName) {
        return this.apiService.apiCall("POST", "access-logs", { roleType: roleType, companyId: companyId, type: type, firstName: firstName, lastName: lastName, companyName: companyName }, undefined, undefined, undefined, "v2");
    };
    /**
     * Create accessLog with given role per QRcode area
     *
     * @since 1.0.0
     *
     * @param data New accessLog's data
     */
    AccessLogsService.prototype.Qrcode = function (roleType, type, firstName, lastName, companyName, companyId) {
        var chosenRole = {
            roleType: roleType,
            company: companyId
        };
        return this.apiService.apiCall("POST", "access-logs/qrcode", { chosenRole: chosenRole, companyId: companyId, type: type, firstName: firstName, lastName: lastName, companyName: companyName }, undefined, undefined, undefined, "v2");
    };
    /**
     * Get access logs list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    AccessLogsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "access-logs", params, undefined, undefined, undefined, "v2");
    };
    /**
     * Get an exportation file of all compananies
     *
     * @since 1.0.0
     */
    AccessLogsService.prototype.getExport = function (companyId) {
        var _this = this;
        if (companyId) {
            return this.apiService
                .apiCall("GET", "access-logs/export/" + companyId, {}, { responseType: "blob" }, undefined, undefined, "v2")
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
        else {
            return this.apiService
                .apiCall("GET", "access-logs/export", {}, { responseType: "blob" }, undefined, undefined, "v2")
                .pipe(catchError(function (err) {
                return _this.helperService.parseErrorBlob(err);
            }));
        }
    };
    /**
     * Update accessLog with given role
     *
     * @since 1.0.0
     *
     * @param accessId ID of accessLog to update
     * @param data New accessLog's data
     */
    AccessLogsService.prototype.update = function (accessId, roleType, companyId) {
        return this.apiService.apiCall("PUT", "access-logs/" + accessId, { roleType: roleType, companyId: companyId }, undefined, undefined, undefined, "v2");
    };
    AccessLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AccessLogsService_Factory() { return new AccessLogsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: AccessLogsService, providedIn: "root" });
    return AccessLogsService;
}());
export { AccessLogsService };
